import { toCents } from '../utils/money.ts'

export const BILL_ACTION_ITEMS = [
  { key: 'note', label: '新增备注' },
  { key: 'issue', label: '确认出账' },
  { key: 'amount', label: '修改金额' },
  { key: 'group', label: '创建收款账单组' },
  { key: 'money', label: '登记收款' },
  { key: 'delete', label: '删除草稿', danger: true },
  { key: 'archive', label: '归档', danger: true }
] as const

export const BILL_ACTION_DESCRIPTION = {
  delete:
    '仅删除草稿账单。已出账、已作废及存在关联记录的账单逐张返回失败，其他符合条件的草稿正常删除。删除后不可恢复；规则账单可重新生成。',
  note: '保留每张账单的原备注，将新内容换行追加到末尾。追加后的备注最多 5000 字。',
  archive: '允许未结清账单归档。归档后默认列表隐藏，账单状态、待收金额和资金流水保留，可通过归档筛选查看。',
  amount: '在表格中填写修改后的金额。已出账账单会记录增减调整，并作废关联的有效账单组；已作废账单不可修改。',
  issue: '草稿可逐张修改金额；水电可填写用量和单价计算，免费填 0。确认后出账，不登记实际收款。'
} as const

export function billRowActions(row: { status: 'draft' | 'issued' | 'voided'; outstandingAmount: string }) {
  return BILL_ACTION_ITEMS.filter((item) => {
    switch (item.key) {
      case 'issue':
      case 'delete':
        return row.status === 'draft'
      case 'amount':
      case 'group':
        return row.status !== 'voided'
      case 'money':
        return row.status === 'draft' || (row.status === 'issued' && toCents(row.outstandingAmount) > BigInt(0))
      default:
        return true
    }
  })
}
